import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { GenericCollectionService, ChapterEntity } from '../../services/collection-service.service';
import { NavigationService } from '../../services/navigation-service.service';
import { MenuService, Topic } from '../../services/menu.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-menu',
  imports: [CommonModule],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.css',
  standalone: true
})
export class MenuComponent {



  isLargeScreen = false;
  currentTopic = 'kidushin'; // Default topic
  isMenuOpen$: Observable<boolean>;
  topics: Topic[] = [];

  constructor(private collectionService: GenericCollectionService<ChapterEntity>,
    private navigationService: NavigationService,
    private menuService: MenuService){
      this.isMenuOpen$ = this.menuService.isMenuOpen$;
    }



  ngOnInit(): void {    
    this.topics = this.menuService.getTopics();
    // Check if user has a preferred topic in localStorage
    const savedTopic = localStorage.getItem('preferredTopic');
    if (savedTopic) {
      this.currentTopic = savedTopic;
      this.collectionService.setCurrentTopic(savedTopic);
    } else {
      // Initialize with default topic
      this.collectionService.setCurrentTopic(this.currentTopic);
    }
  }

  selectTopic(topicId: string): void {
    this.currentTopic = topicId;
    localStorage.setItem('preferredTopic', topicId);
    // Set the topic in the collection service to trigger data reload
    this.collectionService.setCurrentTopic(topicId);
    // Navigate to home to refresh the view with the new topic
    //this.navigationService.navigateToHome();
  }

  // Navigation methods
  openRandomSection(): void {
    this.navigationService.navigateToRandomSection();
    this.menuService.checkScreenSize();
  }
  
  goToChapters(): void {
    this.navigationService.navigateToChapters();
    this.menuService.checkScreenSize();
  }

  goToExams(): void {
    this.navigationService.navigateToExams();
    this.menuService.checkScreenSize();
  }
}
